import { render, staticRenderFns } from "./AppLargemedia.vue?vue&type=template&id=4b81ece1&scoped=true&"
import script from "./AppLargemedia.vue?vue&type=script&lang=js&"
export * from "./AppLargemedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81ece1",
  null
  
)

export default component.exports